import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-82aafafa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form form" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_tree_view_component = _resolveComponent("tree-view-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingModeOn)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новая группа компонентов (узлов) "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, [
                    _createTextVNode(" Карточка группы компонентов "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.serviceComponentGroup?.name), 1)
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                ref: "jobForm",
                "status-icon": "",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Название группы",
                    "label-position": "top",
                    prop: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Родительская группа",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_tree_view_component, {
                        url: "/api/servicejobcomponentgroups",
                        modelValue: _ctx.ruleForm.parentGroupId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.parentGroupId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Описание группы компонентов (узлов)",
                    "label-position": "top",
                    prop: "description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.description,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                        maxlength: "255",
                        "show-word-limit": "",
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: _ctx.asyncOperationPending,
                                onClick: _ctx.onFormSubmitClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.isCreatingModeOn ? 'Создать' : 'Сохранить'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { onClick: _ctx.onFormCancelClick }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Отменить ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingModeOn)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: _ctx.asyncOperationPending,
                                      onClick: _ctx.onFormDeleteClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить группу ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}